import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// styles
import { MY_RESERVATION_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'
import { multiLineClamp, NotinoLabelLarge400, NotinoLabelRegular400 } from '../../../../styles/helpers'

export const SalonInfo = styled.a<{ $backgroundImage?: string }>`
	${({ $backgroundImage }) => css`
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		width: 100%;
		aspect-ratio: 1.5;
		max-height: 320px;
		padding: 10px;
		background-color: #9f9f9f; // NOTE: no such color in the notino pallet for background
		background-image: linear-gradient(358.12deg, #000000 1.81%, rgba(0, 0, 0, 0) 31.61%), url('${$backgroundImage || ''}');
		background-size: cover;
		background-position: center;
		text-decoration: none;

		@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
			height: 320px;
			padding: 20px;
			aspect-ratio: 2.5;
		}
	`}
`

export const SalonLogoWrapper = styled.div`
	width: 40px;
	height: 40px;
	margin-bottom: 8px;
	text-decoration: none;

	img {
		object-fit: contain;
		width: 100%;
		height: 100%;
	}

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		width: 56px;
		height: 56px;
	}
`

export const BottomArea = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;

	svg {
		flex-shrink: 0;
	}
`

export const BottomAreaLeft = styled.div``

export const SalonName = styled.span`
	display: inline-block;
	font-size: 1.25rem;
	line-height: 2rem;
	font-weight: 500;
	color: ${theme.color.text.inverse};
	${multiLineClamp(2)};

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		font-size: 2.25rem;
		line-height: 3rem;
	}
`

export const SalonAddress = styled.span`
	display: inline-block;
	${NotinoLabelRegular400};
	color: ${theme.color.common.gray90};
	${multiLineClamp(2)};

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		${NotinoLabelLarge400};
	}
`
